import { Navigate } from "react-router-dom";

// ═══════════════════════════════════════════════════════════════════
// REPORTS INDEX - Redirects to homepage for privacy
// ═══════════════════════════════════════════════════════════════════
// We don't want to show a list of all reports to maintain client privacy.
// Users should only access reports via direct URLs shared with them.

export default function ReportsIndex() {
  // Redirect to homepage if someone tries to access /reports
  return <Navigate to="/" replace />;
}